module.exports = __webpack_public_path__ + "media/images/athletes/1875-cf382f2051c4d76644f512ae457aa837.png";